import request from '@/utils/request'

// 分页查询
export function fetchList (data) {
  return request.post('/pc/couponIssue/page', data, {
    trim: true
  })
}

// 新增（派发优惠券，默认待领取）
export function create (data) {
  const params = {
    templateId: data.templateId,
    scene: data.scene || data.useScene,
    userId: data.userId
  }
  return request.post('/pc/couponIssue/issue', null, { params })
}

// 更新
export function updateById (data) {
  return request.post('/pc/couponIssue/updateById', data)
}

// 软删除
export function deleteById (id) {
  return request.get(`/pc/couponIssue/delete/${id}`)
}

// 批量软删除
export function deleteByIdInBatch (ids) {
  return request.get('/pc/couponIssue/delete/batch', {
    params: {
      ids
    }
  })
}

// 核销优惠券
export function useCoupon (code) {
  return request.post(`/pc/couponIssue/use/${code}`)
}
